(function () {
    'use strict';

    angular.module('app.orders', ['angular.filter','smart-table', 'treeControl', 'formly', 'formlyBootstrap', 'ui.utils.masks', 'ngTable']);
})();